import { Autocomplete, Box, Button, Chip, Skeleton, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import DeleteIcon from '@mui/icons-material/Delete';
import { DeletePopup, useDebounce } from '../../../../Components/Common Components/CommonComponents'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import { setCachevalue } from '../../../../Utility/Services/CacheProviderService'


const patientCategory = {
  categoryData: [],
  categorySuggestion: [],
  selectedCategory: '',
  deletePopup: false,
  selectedId: null,
  loadScreen: false
}
const UmaDocPatientCategory = React.forwardRef((data, ref) => {
  const listVal = data
  const [category, setCategory] = useState(patientCategory)
  const [key, setKey] = useState('')
  const debounceQuery = useDebounce(key, 500)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - PATIENT CATEGORY`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - PATIENT CATEGORY`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  const apiCalls = async () => {
    await getPatientCategoryData()
    await getPatientCategorySuggData()
  }

  React.useImperativeHandle(ref, () => ({
    performCategoryAction: () => {
      if (category.selectedCategory !== '') {
        postPatientCategoryData()
      }
    }
  }))

  // useEffect(() => {
  //   if (debounceQuery && category.categoryData) {
  //     if (category.categoryData?.some(item => item.category === debounceQuery)) {
  //       errorMessage('Category Already Exists')
  //     }
  //   }
  // }, [debounceQuery, category.categoryData])

  const getPatientCategorySuggData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_PAT_CATEGORY_SUGG + '?doctor_id=' + (listVal.props?.doctorID || listVal.props.patient_details?.doctor_id));
      if (response.data.status === 'success') {
        setCategory((prev) => ({ ...prev, categorySuggestion: response.data.data }));
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message);
      } else {
        errorMessage(error.message);
      }
    }
  };

  const deletePatientCategorySuggData = async (item) => {
    try {
      let data = {
        id: item?.id,
        doctor_id: listVal.props?.doctorID || listVal?.props?.patient_details?.doctor_id
      }
      const response = await RestAPIService.delete(Serviceurls.NEW_DOC_NOTES_PAT_CATEGORY_SUGG, data);
      if (response.data.status === 'success') {
        successMessage(response.data.message);
        await getPatientCategorySuggData();
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message);
      } else {
        errorMessage(error.message);
      }
    }
  }

  const getPatientCategoryData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_PAT_CATEGORY +
        '?patient_id=' + data?.props?.patient_id +
        '&appointment_id=' + data?.props?.appointment_id +
        '&doctor_id=' + (listVal.props?.doctorID || listVal.props.patient_details?.doctor_id)
      );
      if (response.data.status === 'success') {
        setCategory((prev) => ({ ...prev, categoryData: response.data.data, loadScreen: true }))
        data.patientCategoryData(true)
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message);
      } else {
        errorMessage(error.message);
      }
    }
  };

  const postPatientCategoryData = async (item) => {
    try {
      let catValue = item ? item : category?.selectedCategory
      let list = {
        appointment_id: data?.props?.appointment_id,
        patient_category: catValue,
        doctor_id: listVal.props?.doctorID || listVal?.props?.patient_details?.doctor_id,
        patient_id: data?.props?.patient_id
      }
      let hasDuplicate = category.categoryData?.some(item => item.category === catValue)
      if (!hasDuplicate) {
        const response = await RestAPIService.create(list, Serviceurls.NEW_DOC_NOTES_PAT_CATEGORY);
        if (response.data.status === 'success') {
          successMessage(response.data.message);
          await getPatientCategoryData();
          await getPatientCategorySuggData()
          setCategory((prev) => ({ ...prev, selectedCategory: '' }))
          data.patientCategoryData(true)
        }
      } else {
        errorMessage('Category Already Exists')
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message);
      } else {
        errorMessage(error.message);
      }
    }
  };

  const deletePatientCategoryData = async () => {
    try {
      let data = {
        id: category.selectedId,
        doctor_id: listVal.props?.doctorID || listVal?.props?.patient_details.doctor_id
      }
      const response = await RestAPIService.delete(Serviceurls.NEW_DOC_NOTES_PAT_CATEGORY, data);
      if (response.data.status === 'success') {
        successMessage(response.data.message);
        await getPatientCategoryData();
        setCategory((prev) => ({
          ...prev,
          deletePopup: false,
          selectedId: null
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message);
      } else {
        errorMessage(error.message);
      }
    }
  };

  const popupClose = () => {
    setCategory((prev) => ({ ...prev, deletePopup: false }))
  }

  return (
    <ShowComponents onIntersection={apiCalls}>
      <Box component={'div'}>
        <Box component={'div'}>
          <Box component={'div'} className='doc_notes_header_card'>
            <Typography className='doc_notes_header_card_font'>Patient Category</Typography>
          </Box>
          <Box component={'div'} p={'0.5rem'}>
            <Box component={'div'}>
              <Autocomplete
                disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                clearIcon
                size='small'
                fullWidth
                freeSolo
                options={category.categorySuggestion}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.category}
                value={category.selectedCategory}
                onChange={(e, newValue) => {
                  if (category.categoryData?.some(item => item.category === newValue?.category)) {
                    errorMessage('Category Already Exists')
                  } else {
                    setCategory((prev) => ({ ...prev, selectedCategory: newValue?.category }))
                  }
                }}
                renderInput={(params) => <TextField
                  {...params}
                  inputProps={{ maxLength: 100, ...params.inputProps }}
                  InputProps={{ ...params.InputProps, emed_tid: 'pat_cat', maxLength: 100 }}
                  label='Enter or Select Patient Category'
                  onChange={(e) => {
                    setCategory((prev) => ({ ...prev, selectedCategory: e.target.value }))
                    setKey(e.target.value)
                  }}
                />}
                renderOption={(props, item) => {
                  return (
                    <Box component={'div'} display={'flex'} justifyContent={'space-between'} key={props["data-option-index"]}>
                      <Box component="li" {...props} width={'100%'}>
                        <Typography>{item?.category}</Typography>
                      </Box>
                      {
                        <Button className='Common_Btn_Min_Width' emed_tid='pat_cat_dlt'
                          onClick={() => { deletePatientCategorySuggData(item) }}
                        ><DeleteIcon color='error' /></Button>}
                    </Box>
                  )
                }}
              />
            </Box>
            <Box component={'div'}>
              {category?.categoryData?.length > 0 ? category?.categoryData?.map((item, index) => {
                return (
                  <Chip
                    className='eMed_chip eMed_Chip_Border'
                    size="small"
                    label={item.category}
                    key={index}
                    variant='outlined'
                    disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                    emed_tid='pat_dlt_cat'
                    onDelete={() => {
                      setCategory({ ...category, deletePopup: true, selectedId: item?.id })
                    }}
                  />
                )
              }) : null}
            </Box>
          </Box>
        </Box>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
        {category.deletePopup ? <DeletePopup
          DeletTitle={`Are you sure you want to delete ?`}
          deleteAlertPopupClose={popupClose}
          removeData={deletePatientCategoryData}
          disable={category.removeData}
        /> : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaDocPatientCategory